import { DataBean } from "../DataBean";

export class IncomeAdjustmentByValue extends DataBean {



    public async createDocumentIncomeAdjustmentByValue(idIncomeDocument: any, year: any, accountantDate: any, idIncomeResponsibleConcept: any, idAccount: any, idBusinessCore: any, idProject: any, description: any, value, idEmployee: any, createPdf: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore",
            "com.quickdataerp.bean.accountant.AccountantDocument_createDocumentIncomeAdjustment_Number_Number_java.util.Date_Number_Number_Number_Number_String_Number_Number_Boolean", [idIncomeDocument, year, accountantDate, idIncomeResponsibleConcept, idAccount, idBusinessCore, idProject, description, value, idEmployee, createPdf]);
    }

}